(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[968],{

/***/ 8942:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[site]/news/[categorySlug]/[page]",
      function () {
        return __webpack_require__(4025);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2583:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Loading_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9152);
/* harmony import */ var _Loading_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Loading_module_css__WEBPACK_IMPORTED_MODULE_2__);




function Loading(param) {
    var initialColours = param.initialColours, hideLinks = param.hideLinks, className = param.className, children = param.children;
    var initialPageColour = initialColours.initialPageColour, initialUiColour = initialColours.initialUiColour;
    var setInitialPageColour = initialPageColour ? initialPageColour : "#fff";
    var setInitialUiColour = initialUiColour ? initialUiColour : "#000";
    // const setInitialTextColour = initialTextColour ? initialTextColour : '#000'
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                dangerouslySetInnerHTML: {
                    __html: "body { background-color: ".concat(initialPageColour, " }\n            #header *,\n            #header-title * {\n              color: ").concat(hideLinks ? initialPageColour : initialUiColour, "!important\n            }\n            #header *::before,\n            #header *::after,\n            #header-title-line { \n              background-color: ").concat(hideLinks ? initialPageColour : initialUiColour, "!important\n            }")
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Loading_module_css__WEBPACK_IMPORTED_MODULE_2___default().container), (classnames__WEBPACK_IMPORTED_MODULE_1___default())),
                style: {
                    backgroundColor: setInitialPageColour
                },
                children: children
            })
        ]
    });
}
Loading.propTypes = {
    initialColours: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().object),
    hideLinks: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().bool),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
    children: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().node)
};
Loading.defaultProps = {
    initialColours: {},
    hideLinks: false,
    className: "",
    children: null
};
/* harmony default export */ __webpack_exports__["Z"] = (Loading);


/***/ }),

/***/ 4636:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7582);
/* harmony import */ var _getSites__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2007);
/* harmony import */ var lib_withApollo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9849);
/* harmony import */ var graphql_sites_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6717);





var getSitesForStaticPaths = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
        var query, processItems, hasMore, sites;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    query = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : null, processItems = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : null, hasMore = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : null;
                    return [
                        4,
                        (0,_getSites__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)()
                    ];
                case 1:
                    sites = _state.sent();
                    if (!sites) return [
                        2,
                        null
                    ];
                    if (!query) return [
                        2,
                        sites.map(function(s) {
                            return s.path.replace(/\//g, "");
                        })
                    ];
                    return [
                        4,
                        Promise.all(sites.map(function(site) {
                            var siteSlug = site.path.replace(/\//g, "");
                            var items = [];
                            return new Promise(function(resolve, reject) {
                                var runQuery = function(offset) {
                                    var freshClient = (0,lib_withApollo__WEBPACK_IMPORTED_MODULE_1__/* .apolloClient */ .l)();
                                    freshClient.query(query({
                                        site: siteSlug,
                                        offset: offset
                                    })).then(function() {
                                        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(param) {
                                            var data, newItems;
                                            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        data = param.data;
                                                        return [
                                                            4,
                                                            processItems(data, {
                                                                offset: offset,
                                                                client: freshClient,
                                                                site: siteSlug
                                                            })
                                                        ];
                                                    case 1:
                                                        newItems = _state.sent();
                                                        if (Array.isArray(newItems)) newItems.forEach(function(p) {
                                                            return items.push(p);
                                                        });
                                                        else items.push(newItems);
                                                        if (typeof hasMore === "function" && hasMore(data)) {
                                                            runQuery(Array.isArray(newItems) ? offset + newItems.length : newItems.offset);
                                                        } else {
                                                            resolve([
                                                                siteSlug,
                                                                items
                                                            ]);
                                                        }
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        });
                                        return function(_) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }()).catch(function(err) {
                                        console.error("Error fetching graphql query in getSitesForStaticPaths", err, siteSlug, offset, query({
                                            site: siteSlug,
                                            offset: offset
                                        }));
                                        reject("Error fetching graphql query in getSitesForStaticPaths");
                                    });
                                };
                                return runQuery(0);
                            });
                        }))
                    ];
                case 2:
                    // todo: add more error handling on the various fetches
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getSitesForStaticPaths() {
        return _ref.apply(this, arguments);
    };
}();
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (getSitesForStaticPaths)));


/***/ }),

/***/ 4025:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _categorySlug_page_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 13 modules
var lib = __webpack_require__(5063);
;// CONCATENATED MODULE: ./graphql/categories.query.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query CATEGORIES_QUERY {\n    categories(first: 100) {\n      nodes {\n        slug\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var CATEGORIES_QUERY = (0,lib/* gql */.Ps)(_templateObject());
/* harmony default export */ var categories_query = ((/* unused pure expression or super */ null && (CATEGORIES_QUERY)));

// EXTERNAL MODULE: ./helpers/getSitesForStaticPaths.js
var getSitesForStaticPaths = __webpack_require__(4636);
// EXTERNAL MODULE: ./pages/[site]/news/archive/[page].js
var _page_ = __webpack_require__(3402);
;// CONCATENATED MODULE: ./pages/[site]/news/[categorySlug]/[page].js





function CategoryArchivePage(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(_page_["default"], (0,_object_spread/* default */.Z)({}, props));
}
var __N_SSG = true;
/* harmony default export */ var _categorySlug_page_ = (CategoryArchivePage);


/***/ }),

/***/ 3402:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var helpers_getSitesForStaticPaths__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4636);
/* harmony import */ var components_Layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3825);
/* harmony import */ var components_Loading__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2583);
/* harmony import */ var components_WordpressSEO__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1610);
/* harmony import */ var components_NewsHeader__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9753);
/* harmony import */ var components_ArticleGrid__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6253);
/* harmony import */ var components_Pagination__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(919);
/* harmony import */ var _archive_module_css__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(1159);
/* harmony import */ var _archive_module_css__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_archive_module_css__WEBPACK_IMPORTED_MODULE_9__);











function Archive(param) {
    var globalSettings = param.globalSettings, categorySlug = param.categorySlug, page = param.page, site = param.site, posts = param.posts, categoriesMenu = param.categoriesMenu, offsetPagination = param.offsetPagination;
    var ref, ref1, ref2, ref3;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    if (router.fallback || !page) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Loading__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {});
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_Layout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        globalSettings: globalSettings,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_WordpressSEO__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                url: "/".concat(site, "/news/archive/").concat(page),
                title: "Archive",
                desc: "Latest news from our talent and models at Select Model London. Select Model Management is an iconic global network of boutique model and talent agencies.",
                image: posts === null || posts === void 0 ? void 0 : (ref = posts.nodes) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.acfPost) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.featuredImage) === null || ref3 === void 0 ? void 0 : ref3.mediaItemUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_NewsHeader__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                categorySlug: categorySlug,
                categories: categoriesMenu
            }),
            (posts === null || posts === void 0 ? void 0 : posts.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_ArticleGrid__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                className: (_archive_module_css__WEBPACK_IMPORTED_MODULE_9___default().posts),
                articleClassName: (_archive_module_css__WEBPACK_IMPORTED_MODULE_9___default().post),
                articles: posts
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Pagination__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                pagination: offsetPagination,
                currentPage: parseInt(page, 10)
            })
        ]
    });
}
Archive.propTypes = {
    globalSettings: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().object),
    posts: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().array),
    categorySlug: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    offsetPagination: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().object)
};
Archive.defaultProps = {
    globalSettings: {},
    posts: null,
    categorySlug: "",
    offsetPagination: {}
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (Archive);


/***/ }),

/***/ 9152:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"Loading_spacing--xxxs__mrBZx","spacing--xxs":"Loading_spacing--xxs__gJPeb","spacing--xs":"Loading_spacing--xs__f8_dP","spacing--sm":"Loading_spacing--sm__BQT8f","spacing--md":"Loading_spacing--md__wjnkH","spacing--lg":"Loading_spacing--lg__vQy0F","spacing--xl":"Loading_spacing--xl__4069e","spacing--xxl":"Loading_spacing--xxl__MMJcu","spacing--xxxl":"Loading_spacing--xxxl__uHHvb","container":"Loading_container__gSMkV","fadeInItems":"Loading_fadeInItems__IBCzh"};

/***/ }),

/***/ 1159:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"archive_spacing--xxxs__eVaOY","spacing--xxs":"archive_spacing--xxs__BLXwL","spacing--xs":"archive_spacing--xs__huRmU","spacing--sm":"archive_spacing--sm__xFqDK","spacing--md":"archive_spacing--md__ML5w7","spacing--lg":"archive_spacing--lg__hSG2g","spacing--xl":"archive_spacing--xl__7c4cW","spacing--xxl":"archive_spacing--xxl__UDe_D","spacing--xxxl":"archive_spacing--xxxl__e4AwT","posts":"archive_posts__uXMyc","post":"archive_post__h7587","fadeInItems":"archive_fadeInItems__9DzCt"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [333,216,462,774,888,179], function() { return __webpack_exec__(8942); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);